import {
  db,
} from "../../../firebase/config";

import {
  collection,
  addDoc,
  serverTimestamp,
  query,
  where,
  orderBy,
} from "firebase/firestore";

export const listenToInternalNotesFromFirestore = (
  projectId
) => {
  return query(
    collection(db, "internalNotes"),
    where(
      "projectId",
      "==",
      projectId
    ),
    orderBy("createdAt", "desc")
  );
};

export const addInternalNoteToFirestore =
  async ({
    note,
    projectId,
    createdBy,
  }) => {
    return addDoc(
      collection(db, "internalNotes"),
      {
        note,
        projectId,
        createdBy,
        createdAt:
          serverTimestamp(),
      }
    );
  };